/**
 * Browser Detection Utility
 * Detects iOS in-app browsers (Facebook, Instagram, etc.)
 * and provides helpers for compatibility workarounds.
 */

const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';

/** Is the device running iOS? */
export const isIOS = () => {
  return /iPad|iPhone|iPod/.test(ua) || 
    (typeof navigator !== 'undefined' && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

/** Is this Facebook's in-app browser? */
export const isFacebookBrowser = () => /FBAN|FBAV/.test(ua);

/** Is this Instagram's in-app browser? */
export const isInstagramBrowser = () => /Instagram/.test(ua);

/** Is this Twitter/X's in-app browser? */
export const isTwitterBrowser = () => /Twitter/.test(ua);

/** Is this LinkedIn's in-app browser? */
export const isLinkedInBrowser = () => /LinkedInApp/.test(ua);

/** Is this TikTok's in-app browser? */
export const isTikTokBrowser = () => /BytedanceWebview|TikTok/.test(ua);

/** Is this ANY social in-app browser? */
export const isSocialInAppBrowser = () => 
  isFacebookBrowser() || isInstagramBrowser() || isTwitterBrowser() || isLinkedInBrowser() || isTikTokBrowser();

/** Is this an iOS in-app browser specifically? (the problematic combo) */
export const isIOSInAppBrowser = () => isIOS() && isSocialInAppBrowser();

/** Get a label for the detected browser environment */
export const getBrowserLabel = () => {
  if (isFacebookBrowser()) return isIOS() ? 'ios_facebook_webview' : 'facebook_webview';
  if (isInstagramBrowser()) return isIOS() ? 'ios_instagram_webview' : 'instagram_webview';
  if (isTwitterBrowser()) return isIOS() ? 'ios_twitter_webview' : 'twitter_webview';
  if (isLinkedInBrowser()) return isIOS() ? 'ios_linkedin_webview' : 'linkedin_webview';
  if (isTikTokBrowser()) return isIOS() ? 'ios_tiktok_webview' : 'tiktok_webview';
  if (isIOS()) return 'ios_safari';
  return 'standard';
};

/** Get the name of the parent app (for display in banners) */
export const getParentAppName = () => {
  if (isFacebookBrowser()) return 'Facebook';
  if (isInstagramBrowser()) return 'Instagram';
  if (isTwitterBrowser()) return 'X (Twitter)';
  if (isLinkedInBrowser()) return 'LinkedIn';
  if (isTikTokBrowser()) return 'TikTok';
  return null;
};
